import {
  BlotterTable,
  EMPTY_ARRAY,
  useBehaviorSubject,
  useBlotterTable,
  type CareOrder,
  type MinimalSubscriptionResponse,
} from '@talos/kyoko';
import { useMemo } from 'react';
import { useCareOrderNettingPreviewColumns } from './useCareOrderNettingPreviewColumns';

interface PreviewBlotterProps {
  previewWorkingOrder?: CareOrder;
  showAllDecimals: boolean;
}

export function PreviewBlotter({ previewWorkingOrder, showAllDecimals }: PreviewBlotterProps) {
  const rows = useMemo(
    () => (previewWorkingOrder == null ? EMPTY_ARRAY : [previewWorkingOrder]),
    [previewWorkingOrder]
  );
  const columns = useCareOrderNettingPreviewColumns({});

  const { observable: dataObservable } = useBehaviorSubject(
    () =>
      ({
        initial: true,
        data: rows,
      }) satisfies MinimalSubscriptionResponse<CareOrder>,
    [rows]
  );
  const blotterSettings = useMemo(
    () => ({
      showAllDecimals,
    }),
    [showAllDecimals]
  );

  const blotterTable = useBlotterTable<CareOrder>({
    dataObservable,
    errorObservable: undefined,
    rowID: 'ClOrdID' satisfies keyof CareOrder,
    columns,
    gridOptions: {
      rowSelection: {
        mode: 'multiRow',
        checkboxes: () => false,
        headerCheckbox: false,
        hideDisabledCheckboxes: true,
        enableClickSelection: false,
        copySelectedRows: true,
      },
    },
    exportOptions: {
      name: 'CareOrderNettingPreviewWorkingOrder',
    },
    settings: blotterSettings,
  });

  return <BlotterTable {...blotterTable} />;
}
